import type { PayloadAction, CaseReducer } from '@reduxjs/toolkit';
import { addEditedField } from '../../../../../app/sliceUtils';
import type { CallLogView } from '../../index';
import type { VerificationSliceState } from '../state';

/**
 * Financial Orientation reducer (spec 019 FR-011). Appends a logged call to the working case's call
 * list; SAVE persists the whole view round-trip. The caller/date/number are stamped at log time from
 * the signed-in profile (no dedicated endpoint). COB status edits reuse `updateComboOfBenefitsIssue`.
 */
export const appendCall: CaseReducer<VerificationSliceState, PayloadAction<CallLogView>> = (
  state,
  action,
) => {
  if (!state.current) return;
  state.current.calls = [...(state.current.calls ?? []), action.payload];
  addEditedField(state, 'calls');
};
